export default "__VITE_ASSET__DtT4SlLk__"